import React from "react";

export default function PrivacyPolicy({appName}) {
    return (
        <div className="max-w-5xl mx-auto px-6 py-10 text-gray-800 leading-7">
            <h1 className="text-4xl font-bold mb-8">Kebijakan Privasi {appName}</h1>

            <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">Pendahuluan</h2>

                <p className="mb-4">
                    Kebijakan Privasi berikut ini menjelaskan bagaimana kami,
                    <strong> {appName} (Asosiasi Hijrah Group)</strong>
                    mengumpulkan, menyimpan, menggunakan, mengolah, menguasai,
                    mentransfer, mengungkapkan dan melindungi informasi pribadi anda.
                </p>

                <p className="mb-4">
                    Kebijakan Privasi ini berlaku bagi seluruh pengguna aplikasi,
                    situs web, layanan, atau produk kami.
                </p>

                <p className="mb-4">
                    Website:
                    <a
                        href="https://www.hijrah.co.id"
                        target="_blank"
                        rel="noreferrer"
                        className="text-blue-600 underline ml-1"
                    >
                        www.hijrah.co.id
                    </a>
                </p>

                <ol className="list-decimal pl-6 space-y-2">
                    <li>Informasi pribadi yang dikumpulkan</li>
                    <li>Kapan data pribadi dikumpulkan</li>
                    <li>Pengumpulan data lainnya</li>
                    <li>Pemberian informasi pribadi</li>
                    <li>Kebijakan cookie</li>
                    <li>Keamanan informasi pribadi</li>
                    <li>Perubahan kebijakan</li>
                    <li>Pengakuan dan persetujuan</li>
                    <li>Pendaftaran dan keanggotaan</li>
                    <li>Hubungi kami</li>
                </ol>
            </section>

            <section className="mb-10">
                <h2 className="text-2xl font-semibold mb-4">
                    1. Informasi Pribadi Yang Dikumpulkan
                </h2>

                <p className="mb-4">
                    Kami mengumpulkan informasi yang dapat digunakan untuk
                    mengidentifikasi, menghubungi, atau menemukan seseorang.
                </p>

                <ul className="list-disc pl-6 space-y-2">
                    <li>Nama lengkap</li>
                    <li>Alamat email</li>
                    <li>Nomor telepon</li>
                    <li>Alamat rumah</li>
                    <li>Data identitas</li>
                    <li>Data pembayaran</li>
                    <li>Data biometrik</li>
                    <li>Informasi perangkat</li>
                </ul>
            </section>

            <section className="mb-10">
                <h2 className="text-2xl font-semibold mb-4">
                    2. Kapan Kami Mengumpulkan Data
                </h2>

                <ul className="list-disc pl-6 space-y-2">
                    <li>Saat mendaftar akun</li>
                    <li>Saat menggunakan layanan</li>
                    <li>Saat melakukan transaksi</li>
                    <li>Saat menghubungi customer service</li>
                    <li>Saat menggunakan aplikasi atau website</li>
                </ul>
            </section>

            <section className="mb-10">
                <h2 className="text-2xl font-semibold mb-4">
                    3. Pengumpulan Data Lainnya
                </h2>

                <p className="mb-4">
                    Kami dapat mengumpulkan data perangkat, alamat IP, browser,
                    cookies, lokasi GPS, dan aktivitas penggunaan aplikasi untuk
                    meningkatkan layanan kami.
                </p>
            </section>

            <section className="mb-10">
                <h2 className="text-2xl font-semibold mb-4">
                    4. Pemberian Informasi Pribadi
                </h2>

                <p className="mb-4">
                    Informasi pribadi dapat dibagikan kepada pihak terkait untuk:
                </p>

                <ul className="list-disc pl-6 space-y-2">
                    <li>Penyediaan layanan</li>
                    <li>Proses pembayaran</li>
                    <li>Verifikasi pengguna</li>
                    <li>Kepatuhan hukum</li>
                    <li>Keamanan dan pencegahan fraud</li>
                </ul>
            </section>

            <section className="mb-10">
                <h2 className="text-2xl font-semibold mb-4">
                    5. Kebijakan Cookie
                </h2>

                <p>
                    Kami menggunakan cookies untuk meningkatkan pengalaman pengguna,
                    menyimpan preferensi, dan menganalisis penggunaan website.
                </p>
            </section>

            <section className="mb-10">
                <h2 className="text-2xl font-semibold mb-4">
                    6. Keamanan Informasi Pribadi
                </h2>

                <p>
                    Kami berupaya melindungi data pribadi pengguna dari akses tidak
                    sah, kehilangan, penyalahgunaan, maupun perubahan data.
                </p>
            </section>

            <section className="mb-10">
                <h2 className="text-2xl font-semibold mb-4">
                    7. Perubahan Kebijakan
                </h2>

                <p>
                    Kebijakan privasi dapat diperbarui sewaktu-waktu sesuai kebutuhan
                    layanan dan perubahan peraturan.
                </p>
            </section>

            <section className="mb-10">
                <h2 className="text-2xl font-semibold mb-4">
                    8. Pengakuan dan Persetujuan
                </h2>

                <p>
                    Dengan menggunakan layanan kami, anda dianggap telah membaca,
                    memahami, dan menyetujui kebijakan privasi ini.
                </p>
            </section>

            <section className="mb-10">
                <h2 className="text-2xl font-semibold mb-4">
                    9. Pendaftaran & Keanggotaan
                </h2>

                <p className="mb-4">
                    Dengan membuat akun, anda menyatakan bahwa data yang diberikan
                    adalah benar, lengkap, dan terbaru.
                </p>
            </section>

            <section className="mb-10">
                <h2 className="text-2xl font-semibold mb-4">
                    10. Hubungi Kami
                </h2>

                <p>
                    Jika memiliki pertanyaan mengenai kebijakan privasi ini, silakan
                    hubungi:
                </p>

                <p className="mt-2 font-medium">
                    Email: it.hijrah@gmail.com
                </p>
            </section>

            <div className="border-t pt-6 text-sm text-gray-500">
                © {new Date().getFullYear()} {appName}. All rights reserved.
            </div>
        </div>
    );
}